import {
  Component,
  effect,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';
import { CommonModule } from '@angular/common';
import {
  KEYCLOAK_EVENT_SIGNAL,
  KeycloakEventType,
  typeEventArgs,
  ReadyArgs,
} from 'keycloak-angular';
import Keycloak from 'keycloak-js';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { client } from './api/client.gen';
import { ClientOptions, createConfig } from './api/client';
import { getEnv } from './app.config';

@Component({
  selector: 'app-root',
  imports: [
    CommonModule,
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatDividerModule,
  ],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.scss',
})
export class AppComponent {
  authenticated = false;
  keycloakStatus: string | undefined;
  username: string | undefined;
  private readonly keycloak = inject(Keycloak);
  private readonly keycloakSignal = inject(KEYCLOAK_EVENT_SIGNAL);

  constructor() {
    effect(() => {
      const keycloakEvent = this.keycloakSignal();

      this.keycloakStatus = keycloakEvent.type;

      if (keycloakEvent.type === KeycloakEventType.Ready) {
        this.authenticated = typeEventArgs<ReadyArgs>(keycloakEvent.args);
        if (this.authenticated) {
          this.username =
            this.keycloak.idTokenParsed?.['preferred_username'] || 'My account';
          this.keycloak
            .loadUserProfile()
            .then((profile) => {
              this.username =
                profile.username || profile.email || this.username;
            })
            .catch(() => {
              /* Keep the token display name if the account API is unavailable. */
            });
        }
      }

      if (keycloakEvent.type === KeycloakEventType.AuthLogout) {
        this.authenticated = false;
      }
    });

    client.setConfig(
      createConfig<ClientOptions>({
        baseUrl: getEnv().api,
      }),
    );
  }

  login() {
    this.keycloak.login({
      scope: 'openid email',
      redirectUri: window.location.origin + '/dashboard',
    });
  }

  logout() {
    this.keycloak.logout({
      redirectUri: window.location.origin + '/',
    });
  }
}
